import { useMemo } from 'react'
import Styles from './MediaQualityIndicator.module.scss'

interface MediaQualityIndicatorProps {
  mediaCount: number
}

const BAR_WIDTH = 225
const INDICATOR_SIZE = 16
const PADDING = 10
const MAX_POSITION = BAR_WIDTH - PADDING - INDICATOR_SIZE / 2

const QUALITY_THRESHOLDS = [
  { max: 10, label: 'insufficient', color: '#ff6c5e' },
  { max: 30, label: 'acceptable', color: '#ffac3d' },
  { max: 50, label: 'good', color: '#a8c73a' },
  { max: 100, label: 'great', color: '#4ec735' },
  { max: Infinity, label: 'excellent', color: '#17c635' },
] as const

const getQualityLevel = (count: number) => {
  for (let i = 0; i < QUALITY_THRESHOLDS.length; i++) {
    const threshold = QUALITY_THRESHOLDS[i]
    const prevMax = i === 0 ? 0 : QUALITY_THRESHOLDS[i - 1].max

    if (count < threshold.max) {
      const progress = (count - prevMax) / (threshold.max - prevMax)
      const segmentWidth = MAX_POSITION / QUALITY_THRESHOLDS.length
      const position = Math.min(PADDING + i * segmentWidth + progress * segmentWidth, MAX_POSITION)

      return { label: threshold.label, position, color: threshold.color }
    }
  }

  const lastThreshold = QUALITY_THRESHOLDS[QUALITY_THRESHOLDS.length - 1]
  return { label: lastThreshold.label, position: MAX_POSITION, color: lastThreshold.color }
}

export const MediaQualityIndicator = ({ mediaCount }: MediaQualityIndicatorProps) => {
  const quality = useMemo(() => getQualityLevel(mediaCount), [mediaCount])

  return (
    <div className={Styles.container}>
      <div className={Styles.text}>
        This is <span className={Styles.bold}>{quality.label}</span> quantity of media
      </div>
      <div className={Styles.barContainer}>
        <div className={Styles.gradientBar} />
        <div className={Styles.indicator} style={{ left: quality.position, backgroundColor: quality.color }} />
      </div>
    </div>
  )
}
